module.exports = __webpack_public_path__ + "119d9f3484881ef2efb8041b4574f548.png";